/**
 * jai1 tasks dep <childId> <parentId> [-j]
 */
import { Command } from 'commander';
import chalk from 'chalk';
import { TaskService } from '../../services/task.service.js';
import type { TaskDepOptions } from '../../types/task.types.js';

export function createTaskDepCommand(): Command {
    return new Command('dep')
        .description('Add dependency: child depends on parent')
        .argument('<childId>', 'Child task ID (the one that waits)')
        .argument('<parentId>', 'Parent task ID (must be done first)')
        .option('-j, --json', 'Output JSON')
        .action(async (childId: string, parentId: string, options: TaskDepOptions) => {
            const service = new TaskService();

            try {
                const task = await service.addDependency(childId, parentId);

                if (options.json) {
                    console.log(JSON.stringify(task, null, 2));
                    return;
                }

                console.log(chalk.green(`✅ ${childId} now depends on ${parentId}`));
                console.log(chalk.dim(`   ${task.title} → waits for ${parentId}`));
            } catch (error) {
                console.error(chalk.red(`❌ ${error instanceof Error ? error.message : String(error)}`));
                process.exit(1);
            }
        });
}
